<!--TODO: add navigation-->
<div
  class="px-5 pb-4 bg-neutral-100"
  *ngFor="let shopItem of shopItems"
>
  <a (click)="navigateToShop(shopItem.slug)">
    <app-shop-list-atom
      [shopItem]="shopItem"
      [isMarketPlaceAvailable]="isMarketplaceAvailable$ | async"
    ></app-shop-list-atom>
  </a>
</div>
